import axios from '@/api/requests/axios'

export default {
  getAll: (params) => axios.get(`/api/admin/v1/streets`, { params }),
  syncByCityId: (cityId) => axios.put(`/api/admin/v1/streets/${cityId}`)
}
